<template>
  <div :class="['seal-software', 'index-container', {'mobile-content': clientWidth <= mobileWidth}]">
    <common-header
      :is-show-menu="true"
      :client-width="clientWidth"
      current-menu="product"
      @openMobileMenu="openMobileMenu"
    />
    <div class="wrapper">
      <p class="title">资源下载</p>
      <div class="download-container">
        <div v-for="(group, groupIndex) in downloadGroups" :key="groupIndex" class="download-group">
          <div class="group-title">{{ group.category }}</div>
          <div class="group-content">
            <div v-for="(item, itemIndex) in group.items" :key="itemIndex" class="download-item">
              <div class="item-info">
                <div class="item-name">{{ item.name }}</div>
                <div class="item-links">
                  <a :href="item.url" v-if="item.url" target="_blank" class="download-link">
                    <span>下载</span>
                  </a>
                  <a :href="item.manualUrl" target="_blank" class="manual-link" v-if="item.manualUrl">
                    <span>操作手册</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <common-footer v-show="clientWidth > mobileWidth" />
    <mobile-footer v-show="clientWidth <= mobileWidth" />
    <slide-menu ref="slideMenu" />
  </div>
</template>

<script>
import CommonHeader from '@components/CommonHeader.vue';
import CommonFooter from '@components/CommonFooter.vue';
import MobileFooter from '@components/MobileFooter.vue';
import SlideMenu from '@components/Menu.vue';

export default {
  name: 'SealSoftware',
  components: {
    CommonHeader,
    CommonFooter,
    MobileFooter,
    SlideMenu,
  },
  data() {
    return {
      clientWidth: 1920,
      downloadGroups: [
        {
          category: '客户端',
          items: [
            { name: '广烁电子印章客户端（基础版）', url: '/app/广烁电子签章客户端.msi', manualUrl: '/app/广烁电子印章客户端(基础版)操作手册.pdf' },
            { name: 'PDF电子签章客户端（企业新版）', url: 'app/PDF签章客户端（企业新版）.exe', manualUrl: '/app/PDF电子签章客户端(企业新版)操作手册.pdf' },
            { name: '广烁电子印章客户端（OFD版）', url: 'https://www.lngsyz.com/app/oes/client-oes.exe', manualUrl: '/app/广烁电子签章系统终端软件V3.2.1.0操作手册.pdf' },
          ],
        },
        {
          category: '中间件',
          items: [
            { name: '广烁电子印章中间件', url: '/app/广烁电子签章中间件.msi', manualUrl: '' },
          ],
        },
        {
          category: '排版',
          items: [
            { name: '广烁印章排版软件', url: '/app/广烁印章排版系统.msi', manualUrl: '/app/排版软件使用说明.pdf' },
          ],
        },
        {
          category: '运行库',
          items: [
            { name: '微软运行库合集', url: '/app/微软运行库合集.zip', manualUrl: '' },
          ],
        },
        {
          category: '字库',
          items: [
            { name: '常用字体库', url: '/app/Wordzitiku.zip', manualUrl: '' },
          ],
        },
      ],
    };
  },
  computed: {
    mobileWidth() {
      return this.$store.state.common.mobileWidth;
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.clientWidth = document.body.clientWidth;
    },
    openMobileMenu() {
      this.$refs.slideMenu.onOpen();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../less/mobileIndex.less";

.seal-software {
  background: #fff;
  min-height: 100vh;

  .title {
    font-size: 36px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 36px;
    position: relative;
    text-align: center;
    margin: 95px 0;

    &::after {
      position: absolute;
      content: '';
      width: 120px;
      height: 8px;
      background: #F75959;
      border-radius: 4px;
      bottom: -24px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .download-container {
    width: 80%;
    margin: 0 auto 150px;

    .download-group {
      margin-bottom: 40px;

      .group-title {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 28px;
        margin-bottom: 20px;
        padding-left: 10px;
        border-left: 4px solid #F75959;
      }

      .group-content {
        display: flex;
        flex-direction: column;
        gap: 15px;

        .download-item {
          background: #FFFFFF;
          border: 1px solid #E8E8E8;
          border-radius: 8px;
          padding: 20px 30px;
          transition: all 0.3s ease;

          &:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            border-color: #F75959;
          }

          .item-info {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .item-name {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 22px;
              flex: 1;
            }

            .item-links {
              display: flex;
              gap: 20px;

              .download-link,
              .manual-link {
                display: flex;
                align-items: center;
                gap: 8px;
                text-decoration: none;
                color: #1890FF;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                line-height: 20px;
                transition: color 0.3s ease;

                &:hover {
                  color: #F75959;
                }

                .download-icon,
                .manual-icon {
                  width: 16px;
                  height: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.mobile-content {
  .title {
    font-size: 16px;
    margin-bottom: 48px;

    &::after {
      width: 60px;
      height: 4px;
      bottom: -4px;
    }
  }

  .download-container {
    width: 90%;
    margin: 0 auto 130px;

    .download-group {
      margin-bottom: 30px;

      .group-title {
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 15px;
        padding-left: 8px;
        border-left-width: 3px;
      }

      .group-content {
        gap: 10px;

        .download-item {
          padding: 15px 20px;

          .item-info {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;

            .item-name {
              font-size: 14px;
              line-height: 20px;
            }

            .item-links {
              width: 100%;
              justify-content: flex-start;
              gap: 15px;

              .download-link,
              .manual-link {
                font-size: 12px;
                line-height: 16px;

                .download-icon,
                .manual-icon {
                  width: 14px;
                  height: 14px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
